const audiences = [
  {
    icon: 'ri-building-2-line',
    title: 'Kantoren & Bedrijven',
    description: 'Dagelijkse schoonmaak van werkplekken, vergaderruimtes, keukens en sanitaire voorzieningen. Een frisse start voor uw medewerkers.',
  },
  {
    icon: 'ri-store-3-line',
    title: 'Winkels & Retail',
    description: 'Uw winkelvloer en etalages altijd brandschoon. Een schone winkel nodigt uit tot kopen en versterkt uw merkimago.',
  },
  {
    icon: 'ri-restaurant-2-line',
    title: 'Horeca & Hotels',
    description: 'Hygiënische reiniging volgens HACCP-normen voor keukens, eetruimtes en gastenverblijven. Gastvrijheid begint met schoon.',
  },
  {
    icon: 'ri-psychotherapy-line',
    title: 'Zorg & Medisch',
    description: 'Gespecialiseerde reiniging voor praktijken, klinieken en zorginstellingen. Maximale hygiëne voor kwetsbare omgevingen.',
  },
];

export default function TargetAudienceSection() {
  return (
    <section id="voor-wie" className="relative py-24 md:py-32 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-primary-600 mb-4">
            Voor wie
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-5">
            Uw partner in{' '}
            <span className="text-primary-500">schoonmaak</span>
          </h2>
          <p className="text-foreground-600 leading-relaxed">
            Wij werken uitsluitend voor zakelijke opdrachtgevers. Van kleine kantoren tot grote zorginstellingen — 
            elke branche verdient een schone en hygiënische werkomgeving.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {audiences.map((audience) => (
            <div
              key={audience.title}
              className="bg-background-50 rounded-2xl p-8 border border-background-200/70 text-center hover:border-primary-200 transition-all duration-300 cursor-default group"
            >
              <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300 mb-5">
                <i className={`${audience.icon} text-2xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-bold text-foreground-900 mb-3">
                {audience.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {audience.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-accent-100/70 rounded-3xl p-8 md:p-12 text-center border border-accent-200/50">
          <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-4">
            Alleen zakelijk — geen particulieren
          </h3>
          <p className="text-foreground-600 max-w-xl mx-auto leading-relaxed text-sm">
            A&Z Schoonmaakdienst richt zich exclusief op B2B-dienstverlening. Wij werken voor kantoren, 
            winkels, horeca, zorginstellingen en andere zakelijke opdrachtgevers. Heeft u een zakelijke vraag? 
            Neem dan contact met ons op voor een vrijblijvende offerte.
          </p>
        </div>
      </div>
    </section>
  );
}